module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.5b68e9a1.png";